import { useContext, useEffect, useRef, useState } from "react";
import Icon from "./Icon";
import { Context } from "Context";

const mainClass = "help-inline-description";

const InlineDescription = ({
	id,
	text,
	modalContent,
	isMobileView,
	position,
}) => {
	const elementRef = useRef(null);
	const { setModal } = useContext(Context);
	const showTextWithModal = !!(text?.text && text?.modalContent);
	const showModal =
		(modalContent && !text) || (modalContent && text && isMobileView);
	const showText =
		(text && !modalContent) || (modalContent && text && !isMobileView);
		
	const openModal = () => {
		setModal({ ...modalContent, triggerElementRef: elementRef });
		setIsPressed(true);
	};
	const [isPressed, setIsPressed] = useState(false);

	useEffect(() => {
		if (showTextWithModal && elementRef?.current) {
			const elementLink = document.body.querySelector(`a[href="#${id}Modal"]`);
			if (elementLink) {
				elementLink.addEventListener("click", (event) => {
					event.preventDefault();
					setModal({ ...text.modalContent, modifier: "adaptive" });
				});
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [elementRef]);

	if (modalContent && showModal && position === "top") {
		return (
			<button
				ref={elementRef}
				className={`${mainClass}__icon`}
				onClick={openModal}
				aria-haspopup="true"
				aria-pressed={isPressed}
				onBlur={() => setIsPressed(false)}
			>
				<Icon icon="information" />
			</button>
		);
	}

	if (showTextWithModal) {
		return (
			<p
				ref={elementRef}
				className={`${mainClass} ${mainClass}--text-with-modal`}
				dangerouslySetInnerHTML={{ __html: text.text }}
			/>
		);
	}

	return showText &&
		position === "bottom" &&
		text &&
		typeof text !== "object" ? (
		<p className={mainClass} dangerouslySetInnerHTML={{ __html: text }} />
	) : null;
};

export default InlineDescription;
